import * as api from "../api";
import { createApiThunk } from '../features/helpers';
import { createSlice } from "@reduxjs/toolkit";

export const createTip = createApiThunk('tips/addTip', api.createTip, ({navigate, toast}) => {
    toast.success("Dica adicionado com Sucesso");
    navigate(`/`);
});

export const getTipById = createApiThunk('tips/getContentById', api.getTips);

const tips = createSlice({
    name: "tips",
    initialState: {
        tips: [],
        tip: "",
        error: "",
        loading: false,
    },
    extraReducers: {
        [createTip.pending]: (state, action) => {
            state.loading = true;
        },
        [createTip.fulfilled]: (state, action) => {
            state.loading = false;
        },
        [createTip.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        },
        [getTipById.pending]: (state, action) => {
            state.loading = true;
          },
        [getTipById.fulfilled]: (state, action) => {
            state.loading = false;
            console.log('payload: ', action.payload.content);
            state.tips = action.payload.tip;
          },
        [getTipById.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
          },
    }
})

export default tips.reducer;